import { NAVIGATION_PAGES_TO_PATH_MAP } from "./PageNavigation.config";

export const matchesPagePath = (pathname, page) =>
  page.path === pathname || page.aliasPath === pathname;

export const getNavigationState = ({ pathname = "", activePageKey } = {}) => {
  const routeKey = pathname.replace(/^\/+/, "");
  const navigationPages = NAVIGATION_PAGES_TO_PATH_MAP[routeKey] || [];
  const isControlled = activePageKey !== undefined;
  const matchedPageIndex = navigationPages.findIndex((page) =>
    isControlled ? page.key === activePageKey : matchesPagePath(pathname, page),
  );

  return {
    navigationPages,
    isControlled,
    activePageIndex: Math.max(0, matchedPageIndex),
  };
};
